'use client';

import { AdvisorButton } from './AdvisorButton';
import {
  Container,
  HStack,
  InputLabel,
  SearchInput,
  StyledContainer,
  VStack,
} from './SearchAdvisorInput.styles';
import { ADVISOR_URL, useNavigateToAdvisorPage } from '@exploration/ui-utils';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

type Props = {
  ctaButton: string;
  ctaLabel: string;
  ctaText: string;
  ctaButtonTestId?: string;
  ctaLabelTestId?: string;
  ctaTextTestId?: string;
  id?: string;
  showChevron?: boolean;
};

export const SearchAdvisorInput = ({
  ctaLabel,
  ctaButton,
  ctaText,
  ctaButtonTestId,
  ctaLabelTestId,
  ctaTextTestId,
  id,
  showChevron = true,
}: Props) => {
  const [inputValue, setInputValue] = useState('');
  const { push } = useRouter();
  const navigateToAdvisorPage = useNavigateToAdvisorPage();

  return (
    <Container>
      <StyledContainer>
        <VStack>
          <InputLabel data-testid={ctaLabelTestId}>{ctaLabel}</InputLabel>
          <form
            onSubmit={() =>
              navigateToAdvisorPage({
                url: ADVISOR_URL,
                inputValue,
                router: { push },
              })
            }
          >
            <HStack>
              <SearchInput
                name="search-input"
                label="Search by location"
                placeholder={ctaText}
                inputAttributes={{
                  // @ts-expect-error - data-testid works and is covered by homepage.cy.ts
                  'data-testid': ctaTextTestId,
                  'aria-label':
                    'Search financial advisors by zip code, city, or state',
                }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setInputValue(e.currentTarget.value)
                }
              />
              <AdvisorButton
                aria-label={ctaButton}
                buttonId={id}
                showArrow={showChevron}
                advisorSearchText={inputValue}
                data-testid={ctaButtonTestId}
              >
                {ctaButton}
              </AdvisorButton>
            </HStack>
          </form>
        </VStack>
      </StyledContainer>
    </Container>
  );
};
